import type { FC } from 'react';
import { useContext } from 'react';
import { MessageLevel } from './MessageLevel';
import { MessagesContext } from './MessagesContext';
import './MessagesView.scss';

const levelToColor = (level: MessageLevel): string => {
  switch (level) {
    case MessageLevel.Success:
      return 'is-success';
    case MessageLevel.Info:
      return 'is-info';
    case MessageLevel.Warning:
      return 'is-warning';
    case MessageLevel.Danger:
      return 'is-danger';
  }
};

export const MessagesView: FC = () => {
  const { messages, dismiss } = useContext(MessagesContext);

  if (messages.length === 0) {
    return null;
  } else {
    return (
      <aside className={'block'}>
        <ul>
          {messages.map(({ id, level, text }) => {
            return (
              <li className={`notification ${levelToColor(level)}`} key={id}>
                <button
                  className={'delete'}
                  onClick={() => {
                    dismiss(id);
                  }}
                />
                {text}
              </li>
            );
          })}
        </ul>
      </aside>
    );
  }
};
MessagesView.displayName = 'MessagesView';
